import { AppRouteRecordRaw } from '../types';
import { commonRoutes } from './common.routes';
import { dashboardRoutes } from './dashboard.routes';
import { insightsAndAnalyticsRoutes } from './insights-and-analytics.routes';
import { rydMarketingRoutes } from './ryd-marketing.routes';
import { rydCustomerSupportRoutes } from './ryd-customer-support.routes';
import { troubleshootingRoutes } from './troubleshooting.routes';
import { driverAccountManagementRoutes } from './driver-account-management.routes';
import { usersRoutes } from './users.routes';
import { errorRoutes } from './errors.routes';
import { authRoutes } from './auth.routes';
import { partnerAdministrationRoutes } from './partner-administration.routes';
import { partnerOnboardingRoutes } from './partner-onboarding.routes';
import { backofficeRoutes } from './backoffice.routes';
import { aiAssistantsRoutes } from './ai-assistants.routes';
import { internalOperationsRoutes } from './internal-operations.routes';
import { deeplinkManagementRoutes } from './deeplink-management.routes';
import { orderLookupRoutes } from './order-lookup.routes';
import { developerHubRoutes } from './internal-developer-hub.routes';
import { integrationGuideRoutes } from './integration-guide.routes';
import { platformStatusRoutes } from './platform-status.routes';
import { guardianSystemAndAlertsRoutes } from './guardian-system-and-alerts.routes';
import { webhookManagementRoutes } from './webhook-management.routes';
import { accountingRoutes } from './accounting.routes';
import { fleetRoutes } from './fleet.routes';
import { accountManagement } from './account-management';
import { rydFleetOperationsRoutes } from './ryd-fleet-operations.routes';
import { individualPartnersRoutes } from './individual-partners.routes';
import { partnerFleetOperationsRoutes } from './partner-fleet-operations.routes';
import { deeplinkRoutes } from './deeplinks.routes';
import { documentsRoutes } from './documents.routes';
import { portalChangelogRoutes } from './portal-changelog.routes';
import { supportAndFeedbackRoutes } from './support-and-feedback.routes';
import { securityRoutes } from './security.routes';
import { rydPayOperationsRoutes } from './ryd-pay-operations.routes';
import { promoRoutes } from './promo.routes';
import { checkoutRoutes } from './checkout.routes';
import { voucherCampaignsRoutes } from './voucher-campaigns.routes';
import { aiAtRydRoutes } from './ai-at-ryd.routes';
import { securityAndComplianceRoutes } from './security-and-compliance.routes';

export const routes: AppRouteRecordRaw[] = [
  ...commonRoutes,
  ...dashboardRoutes,
  ...insightsAndAnalyticsRoutes,
  ...rydMarketingRoutes,
  ...rydCustomerSupportRoutes,
  ...troubleshootingRoutes,
  ...driverAccountManagementRoutes,
  ...usersRoutes,
  ...errorRoutes,
  ...authRoutes,
  ...partnerAdministrationRoutes,
  ...partnerOnboardingRoutes,
  ...backofficeRoutes,
  ...aiAssistantsRoutes,
  ...internalOperationsRoutes,
  ...deeplinkManagementRoutes,
  ...orderLookupRoutes,
  ...developerHubRoutes,
  ...integrationGuideRoutes,
  ...platformStatusRoutes,
  ...guardianSystemAndAlertsRoutes,
  ...webhookManagementRoutes,
  ...accountingRoutes,
  ...fleetRoutes,
  ...accountManagement,
  ...rydFleetOperationsRoutes,
  ...individualPartnersRoutes,
  ...partnerFleetOperationsRoutes,
  ...deeplinkRoutes,
  ...documentsRoutes,
  ...portalChangelogRoutes,
  ...supportAndFeedbackRoutes,
  ...securityRoutes,
  ...rydPayOperationsRoutes,
  ...promoRoutes,
  ...checkoutRoutes,
  ...voucherCampaignsRoutes,
  ...aiAtRydRoutes,
  ...securityAndComplianceRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/error-404',
  },
];
